import { DictionaryDto } from "../../../../lib/interfaces";

export const fakeBalanceType: DictionaryDto[] = [
  {
    id: 1,
    fromDate: "",
    toDate: "",
    alias: "money",
    dicTypeId: 0,
    dicTypeAlias: "balance_type",
    name: "Денежный",
    abbrev: null,
    dsc: null,
    parentDicId: null,
  },
];
